import { render, staticRenderFns } from "./OurPartners.vue?vue&type=template&id=6e507470&scoped=true"
import script from "./OurPartners.vue?vue&type=script&lang=js"
export * from "./OurPartners.vue?vue&type=script&lang=js"
import style0 from "./OurPartners.vue?vue&type=style&index=0&id=6e507470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e507470",
  null
  
)

export default component.exports